// extracted by mini-css-extract-plugin
export var box = "_6z-1";
export var checked = "_6z-2";
export var descriptionSpacer = "_6z-9";
export var disabled = "_6z-3";
export var icon = "_6z-6";
export var input = "_6z-0";
export var labelSpacer = "_6z-8";
export var medium = "_6z-5";
export var small = "_6z-4";
export var text = "_6z-7";